import type { Store } from '../types/store';
import type { SetupOptions } from '../types/setup-options';
import type { SubscriptionService } from '../types/subscription-service';
import type { PartnerService } from '../types/partner-service';
import messenger from '../messenger';

export class Config {
  private store?: Store;
  private subscriptionService?: SubscriptionService;
  private partnerService?: PartnerService;
  private statePath?: string;

  setup(options: SetupOptions): void {
    const { store, statePath, partnerService, subscriptionService } = options;

    this.store = store;
    this.subscriptionService = subscriptionService;
    this.partnerService = partnerService;
    this.statePath = statePath;
  }

  getStore(): Store {
    if (!this.store) {
      throw new Error(messenger.create('Call "configure" function to setup subscription manager.'));
    }

    return this.store;
  }

  getStatePath(): string {
    return this.statePath || '';
  }

  getSubscriptionService(): SubscriptionService {
    if (!this.subscriptionService) {
      throw new Error(messenger.missingService('subscriptionService', '@yola/yosubscriptions'));
    }

    return this.subscriptionService;
  }

  getPartnerService(): PartnerService {
    if (!this.partnerService) {
      throw new Error(messenger.missingService('partnerService', '@yola/yousers'));
    }

    return this.partnerService;
  }
}

export default new Config();
